<template>
    <div class="grid">
        <div class="col-12">
            <div class="card">
                <h3>Attendance</h3>
                <div class="field grid">
                    <div id="camera" class="flex align-items-center flex-column lg:col-6 mx-auto">
                        <div class="col-12 md:col-12 w-full lg:w-100 rounded-md">
                            <video v-show="!isPhotoTaken" ref="camera" class="box-camera" id="video-camera" autoplay></video>
                            <canvas v-show="isPhotoTaken" id="photoTaken" ref="canvas" class="box-camera"></canvas>
                        </div>
                        <div class="col-2 text-center my-2">
                            <Button class="p-button-lg p-button-rounded" icon="pi pi-camera" @click="takePhoto" />
                        </div>
                        <div class="col-6 text-center">
                            <Button :loading="isSaving" @click="save" id="button1" label="Save"  />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import Button from "primevue/button";
    import Dropdown from "primevue/dropdown";
    import Calendar from "primevue/calendar";
    import Checkbox from "primevue/checkbox";
    import InputText from "primevue/inputtext";
    import AutoComplete from 'primevue/autocomplete';
    import TabView from "primevue/tabview";
    import TabPanel from "primevue/tabpanel";
    import AppLayout from '../../Layouts/AppLayout';
    import axios from "axios";

    export default {
        layout: AppLayout,
        components: {
            Dropdown, Calendar, Checkbox, InputText, AutoComplete, Button, TabView, TabPanel,
        },
        data() {
            return {
                form: this.$page.props.attendance ?? {
                    employee_id: '',
                    is_present: false
                },
                submitted: false,
                autoFilteredValue: [],
                selectedAutoValue: this.$page.props.attendance ? this.$page.props.attendance.employee :  '',
                isSelected: false,
                isSaving: false,
                isEdit: false,
                placements: {},
                divisions: {},
                positions: {},
                deviceId: null,
                img: null,
                camera: null,
                devices: [],
                reasons: ['Ijin Khusus','Ijin Setengah Hari Kerja','Dinas Luar','Pulang Cepat','Sakit Surat Dokter','Cuti','Sakit Tanpa Surat Dokter','Tidak Ada Izin'],
                typeAttendance: ['masuk', 'keluar'],
                // is camera setting
                isCameraOpen: false,
                isPhotoTaken: false,
                isShotPhoto: false,
                user: null
            }
        },
        mounted() {
            navigator.geolocation.getCurrentPosition((position) => {
                const { latitude, longitude } = position.coords
                return this.form = {
                    ...this.form,
                    latitude,
                    longitude
                }
            }, (error) => {
                console.log(error)
            })
            if(this.$page.props.attendance){
                this.isEdit = true;
            }
            this.loadData();
            this.createCameraElement();
            this.getUser();
        },
        methods: {
            loadData() {
                axios.get(`${this.$page.props.appUrl}api/placement-units`)
                    .then((data) => {
                        this.placements = data.data;
                    })
                    .catch((error) => {
                        this.$toast.add({
                            severity: "error",
                            summary: "Error",
                            detail: "Can't Get Data Placement, Refresh Again in 5 second. If still not shown contact support",
                            life: 3000,
                        });
                    });
                axios.get(`${this.$page.props.appUrl}api/divisions`)
                    .then((data) => {
                        this.divisions = data.data;
                    })
                    .catch((error) => {
                        this.$toast.add({
                            severity: "error",
                            summary: "Error",
                            detail: "Can't Get Data Divisions, Refresh Again in 5 second. If still not shown contact support",
                            life: 3000,
                        });
                    });
                axios.get(`${this.$page.props.appUrl}api/positions`)
                    .then((data) => {
                        this.positions = data.data;
                    })
                    .catch((error) => {
                        this.$toast.add({
                            severity: "error",
                            summary: "Error",
                            detail: "Can't Get Data Positions, Refresh Again in 5 second. If still not shown contact support",
                            life: 3000,
                        });
                    });
            },
            save(){
                let photoTaken = document.getElementById('photoTaken').toDataURL('image/jpeg')
                const date = new Date();

                photoTaken = new Blob([photoTaken], {type: 'image/jpeg'})

                const { latitude, longitude, type } = this.form

                let formData = new FormData();
                formData.append('lat_absensi', latitude);
                formData.append('long_absensi', longitude);
                formData.append('image', photoTaken, `image-${Math.floor(Math.random()*11)}.jpeg`);
                const attendanceParams = this.getAttendanceParams()

                axios.post(this.route(`api.overtime.${attendanceParams}`, location.pathname.split('/')[2])+`?user=${this.user.id}`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                })
                .then((data) => {
                    document.location.href = this.route('overtime.user')
                })
                .catch((error) => {
                    console.log(error)
                })

                this.isSaving = false;
                this.submitted = false;

            },
            createCameraElement() {
                const constraints = (window.constraints = {
                    audio: false,
                    video: true
                });

                navigator.mediaDevices
                    .getUserMedia(constraints)
                    .then(stream => {
                        this.isLoading = false;
                        this.$refs.camera.srcObject = stream;
                    })
                    .catch(error => {
                        this.isLoading = false;
                        alert("May the browser didn't support or there is some errors.");
                    });
            },
            stopCamera() {
                navigator.mediaDevices
                    .getUserMedia({audio: false, video: true})
                    .then(stream => {
                        stream.getTracks()
                        .forEach(track => {
                            track.stop()
                        })
                        this.$refs.camera.srcObject = stream
                    })
                    .catch((err) => {
                        console.log(err)
                    })

            },
            takePhoto() {
                if(!this.isPhotoTaken) {
                    this.isShotPhoto = true;

                    const FLASH_TIMEOUT = 50;

                    setTimeout(() => {
                        this.isShotPhoto = false;
                    }, FLASH_TIMEOUT);
                }

                this.isPhotoTaken = !this.isPhotoTaken;

                const context = this.$refs.canvas.getContext('2d');

                // context.imageSmoothingEnabled = false;
                this.$refs.canvas.width = 449.2
                this.$refs.canvas.height = 336.9
                // context.drawImage(this.$refs.camera, 0, 0, 300, 100)
                context.drawImage(this.$refs.camera, 0, 0, 449.2, 336.9)
                this.img = this.$refs.camera;
                if(this.isPhotoTaken) {
                    this.stopCamera()
                } else {
                    this.createCameraElement()
                }
            },
            dataURLtoFile (dataurl, filename) {
                const arr = dataurl.split(',')
                const mime = arr[0].match(/:(.*?);/)[1]
                const bstr = atob(arr[1])
                let n = bstr.length
                const u8arr = new Uint8Array(n)
                while (n) {
                    u8arr[n - 1] = bstr.charCodeAt(n)
                    n -= 1 // to make eslint happy
                }
                return new File([u8arr], filename, { type: mime })
            },
            getUser() {
                this.user = JSON.parse(sessionStorage.getItem('auth:me'))
            },
            getAttendanceParams() {
                let path = location.search.substring(1)
                path = path.split('&')[0]
                path = path.replace('attendance=', '', path)

                return path;
            }
        },
    }
</script>

<style>
    canvas {
        object-fit: contain;
    }
    .box-camera {
        width: 100%;
        background: #b2b2b2;
        border-radius: 20px;
    }
</style>
